"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLaunchAssessmentModal = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var DpModal_1 = __importDefault(require("../Modal/DpModal"));
exports.StyledLaunchAssessmentModal = (0, styled_components_1.default)(DpModal_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .modal-header h4 {\n    font-weight: bold;\n  }\n\n  .modal-body p {\n    color: ", ";\n    font-size: ", ";\n  }\n"], ["\n  .modal-header h4 {\n    font-weight: bold;\n  }\n\n  .modal-body p {\n    color: ", ";\n    font-size: ", ";\n  }\n"])), function (_a) {
    var Brand = _a.theme.Colors.Brand;
    return Brand.normal;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.md;
});
var templateObject_1;
